/* import __COLOCATED_TEMPLATE__ from './list-element.hbs'; */
/**
 ## List Element

 part of the `sq-field-input-searchable` component

### Parameters
@param {Boolean} [isFlipEnabled=true] - Optional - set to false to disable vertical flipping of nested sq-popover component

*/

import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  isFlipEnabled: true,
  extraPopperModifiers: computed('isFlipEnabled', function () {
    return {
      flip: {
        enabled: this.isFlipEnabled
      },
      beforeApplyStyles: {
        // This modifier will run before the applyStyles modifier, which
        // has a default order value of 900.
        order: 900 - 1,
        enabled: true,
        fn: dataObject => {
          const data = dataObject;

          // Popper uses `position: fixed` to unconstrain the dropdown from its
          // parent. This breaks dynamic widths set in CSS, so we have to manually
          // update the width to equal the input field's width.
          data.styles.width = data.offsets.reference.width;

          // If the width of the browser window is an odd number, the left position of the
          // dropdown will be off by one pixel. We fix this by setting the dropdown's
          // left position equal to the input field's left position.
          data.styles.left = data.offsets.reference.left;
          return data;
        }
      }
    };
  })
});